import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { SettingsProvider } from './settings/SettingsContext';
import { LearnerProvider } from './learners/LearnerContext';
import { LanguageProvider } from './i18n/i18n';
import './styles/global.css';
import './games/kit/games.css';
import './media/media.css';
import './talk/talk.css';
import '@fontsource-variable/fraunces';
import '@fontsource-variable/lexend';
import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource-variable/dm-sans';
import '@fontsource-variable/nunito';
import '@fontsource-variable/ibm-plex-sans';
import '@fontsource-variable/space-grotesk';
import '@fontsource/atkinson-hyperlegible/400.css';
import '@fontsource/atkinson-hyperlegible/700.css';
import './designs/themes/scholar.css';
import './designs/themes/fresh.css';
import './designs/themes/pastel.css';
import './designs/themes/symbol.css';
import './designs/themes/classroom.css';
import './designs/themes/tactile.css';
import './designs/themes/clinical.css';
import './designs/themes/editorial.css';
import './designs/themes/bold.css';
import './designs/themes/classic.css';
import './designs/themes/night.css';
import './designs/themes/flow.css';
import './designs/themes/kinetic.css';
import './designs/themes/spring.css';
import '@fontsource-variable/fredoka';
import '@fontsource-variable/baloo-2';
import './designs/playroom/playroom.css';
import './designs/expedition/expedition.css';
import './designs/scene/scene.css';
import './designs/garden/garden.css';
import './designs/popup/popup.css';
import './designs/blocks/blocks.css';
import '@fontsource-variable/manrope';
import '@fontsource-variable/sora';
import '@fontsource-variable/unbounded';
import '@fontsource/instrument-serif/400.css';
import './designs/liquid/liquid.css';
import './designs/liquid/glass.css';
import './designs/liquid/silk.css';
import './designs/liquid/chrome.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
      <AuthProvider>
        <SettingsProvider>
          <LearnerProvider>
            <App />
          </LearnerProvider>
        </SettingsProvider>
      </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
